import React ,{useEffect, useState} from 'react';
import { Button, Divider, Icon, Input, Loader, Dropdown, Segment, Select } from 'semantic-ui-react';
import GConf from 'AssetsM/generalConf';
import { toast } from 'react-toastify';
import axios from 'axios';
import OneGConf from 'AssetsM/OneGConf'
import { useTranslation, Trans } from 'react-i18next';
import { listDemoAccounts } from "../services/fakeApi.js";
import { authService } from "core/auth/authService.js";

function LoginPage({ onLoginSuccess }) {
    /*#########################[Const]##################################*/
    const { t, i18n } = useTranslation();
    const [loginD, setLoginD] = useState({PID: '', subsystem: null, })
    const [mySubSystems, setMySubsystems] = useState([])
    const [loaderState, setLS] = useState(false)
    const [loginCheckValue, setLoginCheckValue] = useState('')
    const [userLoggedCorrectely, setUserLoggedCorrectely] = useState(false)
    const DEMO_ACCOUNTS = listDemoAccounts();
    const [error, setError] = useState(null);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("demo");
    /*#########################[UseEffect]##################################*/
    // useEffect(() => {
    //     if (OneGConf.forPID) {window.location.href = `/${OneGConf.routerName}/L`;} 
    // });

    /*#########################[Functions]##################################*/
    const findTheSystem = () =>{
        if (!loginD.PID) {toast.error("Entrer Un PID !", GConf.TostErrorGonf)}
        else{
            axios.post(`${GConf.SharedApi}/subs/Login/check-pid`, {
                PID : loginD.PID,
            }).then(function (response) {
                console.log(response.data)
                if(response.data.Existance != false ) {
                        setMySubsystems(response.data.subsystems.subsystems)
                        toast.success(" Membre Exist  !", GConf.TostSuucessGonf)
                }
                else{
                    toast.error('Compte Introuvable  ! ', GConf.TostSuucessGonf)
                }
            }).catch((error) => {
                if(error.request) {
                  toast.error(<><div><h5>Probleme de Connextion</h5> Impossible de se connecter aux systeme </div></>, GConf.TostInternetGonf)   
                  setLS(false)
                }
            });
        } 
    }
    const logInSystem = () =>{
        if (!loginD.PID) {toast.error("Entrer Un PID !", GConf.TostErrorGonf)}
        else if (!loginD.Log) {toast.error("Entrer Un identifiant  !", GConf.TostErrorGonf)}
        else if (!loginD.Pwd) {toast.error("Entrer Le mot DP  !", GConf.TostErrorGonf)}
        else if (!loginD.subsystem) {toast.error("Entrer Le mot DP  !", GConf.TostErrorGonf)}
        else{
            let targetSubSystem = mySubSystems.find((data) => data.tag = loginD.subsystem)
            axios.post(`${GConf.SharedApi}/subsystem/LogIn`, {
                LoginData : loginD,
                loginUsedData : {
                        tableToLgIn : targetSubSystem.table,
                        Identifiant : targetSubSystem.idTag,
                        Password : targetSubSystem.passwordTag,
                        LogId : targetSubSystem.checkTag,
                        ID_Tag : 'T_ID'
                    }
            }).then(function (response) {
                console.log(response.data)
                if(response.data.userData != false ) {
                        setUserLoggedCorrectely(true)
                        toast.success(" Membre Exist  !", GConf.TostSuucessGonf)
                }
                else{
                    toast.error('Compte Introuvable  ! ', GConf.TostSuucessGonf)
                }
            }).catch((error) => {
                if(error.request) {
                  toast.error(<><div><h5>Probleme de Connextion</h5> Impossible de se connecter aux systeme </div></>, GConf.TostInternetGonf)   
                  setLS(false)
                }
            });
        } 
    }
    const CheckLogin = () =>{
        if (!loginCheckValue) {toast.error("Entrer Le Smart ID !", GConf.TostErrorGonf)}
        else if (!loginD.Log) {toast.error("Entrer Un identifiant !", GConf.TostErrorGonf)}
        else if (!loginD.Pwd) {toast.error("Entrer Le mot DP  !", GConf.TostErrorGonf)}
        else{
            let targetSubSystem = mySubSystems.find((data) => data.tag = loginD.subsystem)
            axios.post(`${GConf.SharedApi}/subsystem/LogIn/check`, {
                LoginData : loginD,
                loginCheckValue : loginCheckValue,
                loginUsedData : {
                        tableToLgIn : targetSubSystem.table,
                        Identifiant : targetSubSystem.idTag,
                        Password : targetSubSystem.passwordTag,
                        LogId : targetSubSystem.checkTag,
                        ID_Tag : 'T_ID'
                    }
            }).then(function (response) {
                if(response.data.length != 0 ) {
                        toast.success("Connecteé !", GConf.TostSuucessGonf)
                        localStorage.setItem(`${OneGConf.routerTagName}_offline`, JSON.stringify(OneGConf.default_Offline));
                        localStorage.setItem(`${OneGConf.routerTagName}_forPID`, JSON.stringify(response.data));
                        window.location.href = `/${OneGConf.routerName}`;
                        
                }
                else{
                    toast.error('Compte Indéfine ! ', GConf.TostSuucessGonf)
                    
                }
            }).catch((error) => {
                if(error.request) {
                  toast.error(<><div><h5>Probleme de Connextion</h5> Impossible de se connecter aux systeme </div></>, GConf.TostInternetGonf)   
                  setLS(false)
                }
            });
        } 
    }
    const SelectCountry = (lan, country) => {
        i18n.changeLanguage(lan)
        localStorage.setItem('country', country);    
    }
    async function submit(targetEmail) {
        setError(null);
        setLS(true);
        try {
        const session = await authService.login(targetEmail ?? email, password);
        onLoginSuccess(session);
        } catch (err) {
        setError(err.message ?? "Login failed");
        } finally {
        setLS(false);
        }
    }

    return ( <>

             <div className='container d-flex align-items-center justify-content-center' style={{paddingTop:'80px'}}>
                <div className='col-12 col-lg-5'>
                    <Segment padded className='sub-sys-round' style={{borderBottom:`3px solid ${GConf.themeColor}`}}>
                                <div className='text-end '>
                                    <Dropdown floating scrolling   labeled  button direction='left'  icon={<span className='bi bi-translate bi-sm text-info'></span>}>
                                        <Dropdown.Menu >
                                            <Dropdown.Item className='text-start' onClick={() => SelectCountry('en_US','US')}>  <img src="https://flagcdn.com/us.svg" className="img-responsive   border" width="10px" height="25px" /> English  </Dropdown.Item>
                                            <Dropdown.Item className='text-start' onClick={() => SelectCountry('fr_FR','FR')}>  <img src="https://flagcdn.com/fr.svg" className="img-responsive   border" width="10px" height="25px" /> Français  </Dropdown.Item>
                                            <Dropdown.Item className='text-start' onClick={() => SelectCountry('zh_CN','CN')}>  <img src="https://flagcdn.com/cn.svg" className="img-responsive   border" width="10px" height="25px" /> Chineese  </Dropdown.Item>
                                            <Dropdown.Item className='text-start' onClick={() => SelectCountry('hi','IN')}>  <img src="https://flagcdn.com/in.svg" className="img-responsive   border" width="10px" height="25px" /> Hindi  </Dropdown.Item>
                                            <Dropdown.Item className='text-start' onClick={() => SelectCountry('ru','RU')}>  <img src="https://flagcdn.com/ru.svg" className="img-responsive   border" width="10px" height="25px" /> Russian  </Dropdown.Item>
                                            <Dropdown.Item className='text-start' onClick={() => SelectCountry('ja','JP')}>  <img src="https://flagcdn.com/pa.svg" className="img-responsive   border" width="10px" height="25px" /> Japonny  </Dropdown.Item>
                                            <Dropdown.Item className='text-start' onClick={() => SelectCountry('de_DE','DE')}>  <img src="https://flagcdn.com/de.svg" className="img-responsive   border" width="10px" height="25px" /> Germany  </Dropdown.Item>
                                            <Dropdown.Item className='text-start' onClick={() => SelectCountry('it_IT','IT')}>  <img src="https://flagcdn.com/it.svg" className="img-responsive   border" width="10px" height="25px" /> Italy  </Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                                <h2 className='text-cente mt-1'><Icon name='linkify' />{t('alternativeS.rdvPortail.loginInPage.connextionText')}</h2>
                                <br />
                                
 
                                    <div className='mb-3'>
                                    <Input   icon='user' iconPosition='left' placeholder='PID' className='shadow-sm w-100' onChange={(e) => setLoginD({...loginD, PID: e.target.value })}/>
                                    </div>
                                    
                                    <div className='mb-3'>
                                        <Button onClick={findTheSystem}  style={{backgroundColor:GConf.themeColor, color:'white'}} className='shadow-sm w-100'> Trouver le system ? <Loader inverted active={loaderState} inline size='tiny' className='ms-2 text-danger'/></Button>
                                    </div>
                                    {
                                        mySubSystems.length != 0 ? 
                                        <div className='mb-3'>
                                            <Select   options={mySubSystems.map((data, index) =>  ({ key:index , value : data.tag , text: data.nom }))}  placeholder='System' className='shadow-sm w-100' onChange={(e, { value }) => setLoginD({...loginD, subsystem: value })}/>
                                        </div>
                                        :
                                        <></>
                                    }
                                    
                                    {loginD.subsystem ? 
                                    <>
                                        <div className='mb-3'>
                                        <Input   icon='user' iconPosition='left' placeholder={t('alternativeS.rdvPortail.loginInPage.identifiant')} className='shadow-sm w-100' onChange={(e) => setLoginD({...loginD, Log: e.target.value })}/>
                                        </div>
                                        <div className='mb-3'>
                                            <Input  icon='key' iconPosition='left' placeholder={t('alternativeS.rdvPortail.loginInPage.pwd')} type='password' className='shadow-sm w-100' onChange={(e) => setLoginD({...loginD, Pwd: e.target.value })}/>
                                        </div>
                                        <div className='mb-3'>
                                            <Button onClick={logInSystem}  style={{backgroundColor:GConf.themeColor, color:'white'}} className='shadow-sm w-100'>{t('alternativeS.rdvPortail.loginInPage.connBtn')} <Loader inverted active={loaderState} inline size='tiny' className='ms-2 text-danger'/></Button>
                                        </div>
                                        {userLoggedCorrectely ? 
                                            <>
                                                <Divider />
                                                <div className='mb-3'>
                                                    <Input  icon='key' iconPosition='left' placeholder={t('alternativeS.rdvPortail.loginInPage.smartId')}  type='text' className='shadow-sm w-100' onChange={(e) => setLoginCheckValue(e.target.value)}/>
                                                </div>
                                                <div className='mb-3'>
                                                    <Button onClick={() => CheckLogin()}   className='shadow-sm w-100'>{t('alternativeS.rdvPortail.loginInPage.validBtn')} <Loader inverted active={loaderState} inline size='tiny' className='ms-2 text-danger'/></Button>
                                                </div>
                                            </>
                                            :
                                            <></>}
                                    </>
                                    : <></>
                                    }         
                    </Segment>
                
            <div style={{ marginTop: 24 , marginBottom: 20}}>
                <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 8 }}>
                    Or jump straight into a demo system:
                </div>
                <div
                    style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}
                >
                    {DEMO_ACCOUNTS.map((acc) => (
                    <button
                        key={acc.email}
                        type="button"
                        disabled={loaderState}
                        onClick={() => submit(acc.email)}
                        style={demoButtonStyle}
                    >
                        Login as {acc.title.replace(" ERP", "")}
                    </button>
                    ))}
                </div>
            </div>
            </div>
            </div>
            
    </> );
}

export default LoginPage;

const inputStyle = {
  padding: "10px 12px",
  borderRadius: 8,
  border: "1px solid #d1d5db",
  fontSize: 14,
};

const primaryButtonStyle = {
  padding: "10px 12px",
  borderRadius: 8,
  border: "none",
  background: "#2563eb",
  color: "#fff",
  fontWeight: 600,
  cursor: "pointer",
};

const demoButtonStyle = {
  padding: "10px 8px",
  borderRadius: 8,
  border: "1px solid #d1d5db",
  background: "#f9fafb",
  cursor: "pointer",
  fontSize: 13,
};
